import { render, staticRenderFns } from "./homebottom3.vue?vue&type=template&id=9e2de526&scoped=true"
import script from "./homebottom3.vue?vue&type=script&lang=js"
export * from "./homebottom3.vue?vue&type=script&lang=js"
import style0 from "./homebottom3.vue?vue&type=style&index=0&id=9e2de526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2de526",
  null
  
)

export default component.exports